var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("template-list", {
        attrs: { "document-type": 2, value: _vm.editedDelegationOrder },
        on: {
          "update:value": function($event) {
            _vm.editedDelegationOrder = $event
          }
        }
      }),
      _c(
        "h1",
        [
          _vm._v(" " + _vm._s(_vm.$t("delegationOrder.form.title")) + " "),
          _c("delegation-order-travel-service-import", {
            attrs: {
              travel_service_order_ids:
                _vm.editedDelegationOrder.travel_service_order_ids
            },
            on: {
              "update:travel_service_order_ids": function($event) {
                return _vm.$set(
                  _vm.editedDelegationOrder,
                  "travel_service_order_ids",
                  $event
                )
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mt-3 elevation-12 white" },
        [
          _c(
            "v-container",
            { staticClass: "pa-4", attrs: { fluid: "" } },
            [
              _c(
                "v-form",
                { ref: "form" },
                [
                  _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { md: "6", sm: "6", cols: "12" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              "error-messages": _vm.translatedErrors.user_id,
                              items: _vm.users,
                              label: _vm.$t(
                                "delegation.form.fields.delegated.name"
                              ),
                              "item-text": "fullName",
                              "item-value": "id",
                              readonly:
                                _vm.$store.state.DelegationOrder.readonly ===
                                true
                            },
                            model: {
                              value: _vm.contextUserId,
                              callback: function($$v) {
                                _vm.contextUserId = $$v
                              },
                              expression: "contextUserId"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.companies.length > 1
                        ? _c(
                            "v-col",
                            { attrs: { md: "6", sm: "6", cols: "12" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  "error-messages":
                                    _vm.translatedErrors.company_id,
                                  items: _vm.companies,
                                  label: _vm.$t(
                                    "delegation.form.fields.company.name"
                                  ),
                                  "item-text": "name",
                                  "item-value": "id",
                                  readonly:
                                    _vm.$store.state.DelegationOrder
                                      .readonly === true
                                },
                                model: {
                                  value: _vm.editedDelegationOrder.company_id,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editedDelegationOrder,
                                      "company_id",
                                      $$v
                                    )
                                  },
                                  expression: "editedDelegationOrder.company_id"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-col",
                        { attrs: { md: "6", sm: "6", cols: "12" } },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: {
                                disabled:
                                  _vm.$store.state.Auth.userProperties
                                    .system_settings
                                    .delegation_order_number_setting_type !== 2,
                                top: ""
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          {
                                            attrs: {
                                              disabled:
                                                _vm.$store.state.Auth
                                                  .userProperties
                                                  .system_settings
                                                  .delegation_order_number_setting_type ===
                                                3,
                                              "error-messages":
                                                _vm.translatedErrors
                                                  .custom_number,
                                              label: _vm.$t(
                                                "delegationOrder.form.fields.number.name"
                                              ),
                                              placeholder:
                                                _vm.$store.state.Auth
                                                  .userProperties
                                                  .system_settings
                                                  .delegation_order_number_setting_type !==
                                                1
                                                  ? _vm.$t(
                                                      "delegation.form.fields.delegationNumber.willBeAuto"
                                                    )
                                                  : null,
                                              readonly:
                                                _vm.$store.state.DelegationOrder
                                                  .readonly === true
                                            },
                                            model: {
                                              value:
                                                _vm.editedDelegationOrder
                                                  .custom_number,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.editedDelegationOrder,
                                                  "custom_number",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedDelegationOrder.custom_number"
                                            }
                                          },
                                          on
                                        )
                                      )
                                    ]
                                  }
                                }
                              ])
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "delegation.form.fields.delegationNumber.leftEmptyToAutomatic"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm.$store.getters["userProperties"].system_settings
                        .is_delegation_task_enabled === 2
                        ? [
                            _c(
                              "v-col",
                              { attrs: { md: "6", sm: "6", cols: "12" } },
                              [
                                _c("v-select", {
                                  attrs: {
                                    "error-messages":
                                      _vm.translatedErrors.task_id,
                                    items: _vm.delegation_tasks,
                                    label: _vm.$t(
                                      "delegation.form.fields.task.name"
                                    ),
                                    readonly:
                                      _vm.$store.state.DelegationOrder
                                        .readonly === true
                                  },
                                  model: {
                                    value: _vm.editedDelegationOrder.task_id,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.editedDelegationOrder,
                                        "task_id",
                                        $$v
                                      )
                                    },
                                    expression: "editedDelegationOrder.task_id"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { md: "6", sm: "6", cols: "12" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    "error-messages": _vm.translatedErrors.task,
                                    label: _vm.$t(
                                      "delegation.form.fields.taskDescription.name"
                                    ),
                                    readonly:
                                      _vm.$store.state.DelegationOrder
                                        .readonly === true
                                  },
                                  model: {
                                    value: _vm.editedDelegationOrder.task,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.editedDelegationOrder,
                                        "task",
                                        $$v
                                      )
                                    },
                                    expression: "editedDelegationOrder.task"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("delegation-order-travel-service", {
                            attrs: {
                              "travel-service-order-ids":
                                _vm.editedDelegationOrder
                                  .travel_service_order_ids
                            },
                            on: {
                              "update:travelServiceOrderIds": function($event) {
                                return _vm.$set(
                                  _vm.editedDelegationOrder,
                                  "travel_service_order_ids",
                                  $event
                                )
                              },
                              "update:travel-service-order-ids": function(
                                $event
                              ) {
                                return _vm.$set(
                                  _vm.editedDelegationOrder,
                                  "travel_service_order_ids",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm.companies.length < 2
                        ? _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("location-ajax-select-multiple", {
                                attrs: {
                                  defaultItems:
                                    _vm.editedDelegationOrder
                                      .destinationObjects,
                                  label: _vm.$t(
                                    "delegation.form.fields.destination.name"
                                  ),
                                  placeholder:
                                    _vm.editedDelegationOrder.destinationText,
                                  "select-model":
                                    _vm.editedDelegationOrder.destination,
                                  "select-text":
                                    _vm.editedDelegationOrder.destinationText,
                                  readonly:
                                    _vm.$store.state.DelegationOrder
                                      .readonly === true,
                                  multiple: true,
                                  "select-validation":
                                    _vm.translatedErrors.destination
                                },
                                on: {
                                  "update:selectModel": function($event) {
                                    return _vm.$set(
                                      _vm.editedDelegationOrder,
                                      "destination",
                                      $event
                                    )
                                  },
                                  "update:select-model": function($event) {
                                    return _vm.$set(
                                      _vm.editedDelegationOrder,
                                      "destination",
                                      $event
                                    )
                                  },
                                  "update:selectText": function($event) {
                                    return _vm.$set(
                                      _vm.editedDelegationOrder,
                                      "destinationText",
                                      $event
                                    )
                                  },
                                  "update:select-text": function($event) {
                                    return _vm.$set(
                                      _vm.editedDelegationOrder,
                                      "destinationText",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.companies.length > 1
                        ? _c(
                            "v-col",
                            { attrs: { cols: "12", md: "6", sm: "6" } },
                            [
                              _c("location-ajax-select-multiple", {
                                attrs: {
                                  defaultItems:
                                    _vm.editedDelegationOrder
                                      .destinationObjects,
                                  label: _vm.$t(
                                    "delegation.form.fields.destination.name"
                                  ),
                                  placeholder:
                                    _vm.editedDelegationOrder.destinationText,
                                  "select-model":
                                    _vm.editedDelegationOrder.destination,
                                  "select-text":
                                    _vm.editedDelegationOrder.destinationText,
                                  readonly:
                                    _vm.$store.state.DelegationOrder
                                      .readonly === true,
                                  multiple: true,
                                  "select-validation":
                                    _vm.translatedErrors.destination
                                },
                                on: {
                                  "update:selectModel": function($event) {
                                    return _vm.$set(
                                      _vm.editedDelegationOrder,
                                      "destination",
                                      $event
                                    )
                                  },
                                  "update:select-model": function($event) {
                                    return _vm.$set(
                                      _vm.editedDelegationOrder,
                                      "destination",
                                      $event
                                    )
                                  },
                                  "update:selectText": function($event) {
                                    return _vm.$set(
                                      _vm.editedDelegationOrder,
                                      "destinationText",
                                      $event
                                    )
                                  },
                                  "update:select-text": function($event) {
                                    return _vm.$set(
                                      _vm.editedDelegationOrder,
                                      "destinationText",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-col",
                        { attrs: { md: "6", sm: "6", cols: "12" } },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "location-ajax-select",
                                        _vm._g(
                                          {
                                            attrs: {
                                              "default-items":
                                                _vm.defaultStartEndLocation,
                                              label: _vm.$t(
                                                "delegationOrder.form.fields.startPlace.name"
                                              ),
                                              placeholder:
                                                _vm.editedDelegationOrder
                                                  .start_place_text,
                                              "select-model":
                                                _vm.editedDelegationOrder
                                                  .start_place_id,
                                              "select-text":
                                                _vm.editedDelegationOrder
                                                  .start_place_text,
                                              readonly:
                                                _vm.$store.state.DelegationOrder
                                                  .readonly === true
                                            },
                                            on: {
                                              "update:selectModel": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.editedDelegationOrder,
                                                  "start_place_id",
                                                  $event
                                                )
                                              },
                                              "update:select-model": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.editedDelegationOrder,
                                                  "start_place_id",
                                                  $event
                                                )
                                              },
                                              "update:selectText": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.editedDelegationOrder,
                                                  "start_place_text",
                                                  $event
                                                )
                                              },
                                              "update:select-text": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.editedDelegationOrder,
                                                  "start_place_text",
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.editedDelegationOrder
                                                  .start_place_id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.editedDelegationOrder,
                                                  "start_place_id",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedDelegationOrder.start_place_id"
                                            }
                                          },
                                          on
                                        )
                                      )
                                    ]
                                  }
                                }
                              ])
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "delegationOrder.form.leftEmptyToSetDefaultPlace"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { md: "6", sm: "6", cols: "12" } },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "location-ajax-select",
                                        _vm._g(
                                          {
                                            attrs: {
                                              "default-items":
                                                _vm.defaultStartEndLocation,
                                              label: _vm.$t(
                                                "delegationOrder.form.fields.endPlace.name"
                                              ),
                                              placeholder:
                                                _vm.editedDelegationOrder
                                                  .end_place_text,
                                              "select-model":
                                                _vm.editedDelegationOrder
                                                  .end_place_id,
                                              "select-text":
                                                _vm.editedDelegationOrder
                                                  .end_place_text,
                                              readonly:
                                                _vm.$store.state.DelegationOrder
                                                  .readonly === true
                                            },
                                            on: {
                                              "update:selectModel": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.editedDelegationOrder,
                                                  "end_place_id",
                                                  $event
                                                )
                                              },
                                              "update:select-model": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.editedDelegationOrder,
                                                  "end_place_id",
                                                  $event
                                                )
                                              },
                                              "update:selectText": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.editedDelegationOrder,
                                                  "end_place_text",
                                                  $event
                                                )
                                              },
                                              "update:select-text": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.editedDelegationOrder,
                                                  "end_place_text",
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.editedDelegationOrder
                                                  .end_place_id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.editedDelegationOrder,
                                                  "end_place_id",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedDelegationOrder.end_place_id"
                                            }
                                          },
                                          on
                                        )
                                      )
                                    ]
                                  }
                                }
                              ])
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "delegationOrder.form.leftEmptyToSetDefaultPlace"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm.isReInvoicingForExternalContractorModuleEnabled
                        ? _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.externalCustomers,
                                  "error-messages":
                                    _vm.translatedErrors.external_customer_id,
                                  clearable:
                                    _vm.$store.state.DelegationOrder
                                      .readonly !== true,
                                  readonly:
                                    _vm.$store.state.DelegationOrder
                                      .readonly === true,
                                  label: _vm.$t(
                                    "delegation.form.fields.externalCustomer.name"
                                  )
                                },
                                on: { change: _vm.changedExternalCustomer },
                                model: {
                                  value:
                                    _vm.editedDelegationOrder
                                      .external_customer_id,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editedDelegationOrder,
                                      "external_customer_id",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "editedDelegationOrder.external_customer_id"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isReInvoicingForExternalContractorModuleEnabled
                        ? _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.projectsForExternalCustomer,
                                  clearable:
                                    _vm.$store.state.DelegationOrder
                                      .readonly !== true,
                                  label: _vm.$t(
                                    "delegation.form.fields.project.name"
                                  ),
                                  "error-messages":
                                    _vm.translatedErrors.project_id,
                                  "persistent-hint": "",
                                  readonly:
                                    _vm.$store.state.DelegationOrder
                                      .readonly === true,
                                  hint:
                                    _vm.editedDelegationOrder.project_id ===
                                    null
                                      ? ""
                                      : _vm.$t("global.orderNumber") +
                                        ": " +
                                        _vm.projects.find(function(v) {
                                          return (
                                            v.value ===
                                            _vm.editedDelegationOrder.project_id
                                          )
                                        }).order_number
                                },
                                model: {
                                  value: _vm.editedDelegationOrder.project_id,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editedDelegationOrder,
                                      "project_id",
                                      $$v
                                    )
                                  },
                                  expression: "editedDelegationOrder.project_id"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-col",
                        { attrs: { md: "6", sm: "6", cols: "12" } },
                        [
                          _c("date-time-picker-model-computed", {
                            attrs: {
                              "date-label": _vm.$t(
                                "delegationOrder.form.fields.startDate.dateLabel"
                              ),
                              "date-time-validation":
                                _vm.translatedErrors.start_date,
                              dateTimeModel:
                                _vm.editedDelegationOrder.start_date,
                              "time-label": _vm.$t(
                                "delegationOrder.form.fields.startDate.timeLabel"
                              ),
                              readonly:
                                _vm.$store.state.DelegationOrder.readonly ===
                                true
                            },
                            on: {
                              "update:dateTimeModel": function($event) {
                                return _vm.$set(
                                  _vm.editedDelegationOrder,
                                  "start_date",
                                  $event
                                )
                              },
                              "update:date-time-model": function($event) {
                                return _vm.$set(
                                  _vm.editedDelegationOrder,
                                  "start_date",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { md: "6", sm: "6", cols: "12" } },
                        [
                          _c("date-time-picker-model-computed", {
                            attrs: {
                              "date-label": _vm.$t(
                                "delegationOrder.form.fields.endDate.dateLabel"
                              ),
                              "date-time-validation":
                                _vm.translatedErrors.end_date,
                              dateTimeModel: _vm.editedDelegationOrder.end_date,
                              "time-label": _vm.$t(
                                "delegationOrder.form.fields.endDate.timeLabel"
                              ),
                              readonly:
                                _vm.$store.state.DelegationOrder.readonly ===
                                true
                            },
                            on: {
                              "update:dateTimeModel": function($event) {
                                return _vm.$set(
                                  _vm.editedDelegationOrder,
                                  "end_date",
                                  $event
                                )
                              },
                              "update:date-time-model": function($event) {
                                return _vm.$set(
                                  _vm.editedDelegationOrder,
                                  "end_date",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { md: "12", sm: "12", cols: "12" } },
                        [
                          _c("delegation-order-restrictions", {
                            attrs: {
                              "allowed-transport-cost-model":
                                _vm.editedDelegationOrder
                                  .allowed_transport_cost,
                              "allowed-transport-model":
                                _vm.editedDelegationOrder.allowed_transport
                            },
                            on: {
                              "update:allowedTransportCostModel": function(
                                $event
                              ) {
                                return _vm.$set(
                                  _vm.editedDelegationOrder,
                                  "allowed_transport_cost",
                                  $event
                                )
                              },
                              "update:allowed-transport-cost-model": function(
                                $event
                              ) {
                                return _vm.$set(
                                  _vm.editedDelegationOrder,
                                  "allowed_transport_cost",
                                  $event
                                )
                              },
                              "update:allowedTransportModel": function($event) {
                                return _vm.$set(
                                  _vm.editedDelegationOrder,
                                  "allowed_transport",
                                  $event
                                )
                              },
                              "update:allowed-transport-model": function(
                                $event
                              ) {
                                return _vm.$set(
                                  _vm.editedDelegationOrder,
                                  "allowed_transport",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { md: "12", sm: "12", cols: "12" } },
                        [
                          _c("collapse-simple-advance-panel", {
                            attrs: {
                              clearable:
                                _vm.$store.state.DelegationOrder.readonly !==
                                true,
                              addable:
                                _vm.$store.state.DelegationOrder.readonly !==
                                true,
                              "model-advances":
                                _vm.editedDelegationOrder.advances,
                              readonly:
                                _vm.$store.state.DelegationOrder.readonly ===
                                true
                            },
                            on: {
                              "update:modelAdvances": function($event) {
                                return _vm.$set(
                                  _vm.editedDelegationOrder,
                                  "advances",
                                  $event
                                )
                              },
                              "update:model-advances": function($event) {
                                return _vm.$set(
                                  _vm.editedDelegationOrder,
                                  "advances",
                                  $event
                                )
                              },
                              addAdvanceItem: _vm.addDelegationAdvance,
                              removeAdvanceItem: _vm.removeAdvance
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { md: "6", sm: "6", cols: "12" } },
                        [
                          _c("date-picker", {
                            attrs: {
                              label: _vm.$t(
                                "delegationOrder.form.fields.settlementDeadline.name"
                              ),
                              model:
                                _vm.editedDelegationOrder.settlement_deadline,
                              placeholder: _vm.defaultSettlementDate,
                              readonly:
                                _vm.$store.state.DelegationOrder.readonly ===
                                true
                            },
                            on: {
                              "update:model": function($event) {
                                return _vm.$set(
                                  _vm.editedDelegationOrder,
                                  "settlement_deadline",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm.$store.state.Auth.userProperties.system_settings
                        .cost_centre_on_delegations !== 3
                        ? _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  "error-messages":
                                    _vm.translatedErrors.cost_centre_id,
                                  items: _vm.availableCostCentres,
                                  label: _vm.$t(
                                    "delegation.form.fields.costCentre.name"
                                  ),
                                  clearable:
                                    _vm.$store.state.DelegationOrder
                                      .readonly !== true,
                                  "item-text": "name",
                                  "item-value": "id",
                                  readonly:
                                    _vm.$store.state.DelegationOrder
                                      .readonly === true
                                },
                                model: {
                                  value:
                                    _vm.editedDelegationOrder.cost_centre_id,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editedDelegationOrder,
                                      "cost_centre_id",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "editedDelegationOrder.cost_centre_id"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-col",
                        [
                          _c("amount-input", {
                            attrs: {
                              "error-messages":
                                _vm.translatedErrors.overall_estimated,
                              model:
                                _vm.editedDelegationOrder.estimated_total_cost,
                              label: _vm.$t(
                                "delegationOrder.form.fields.estimatedTotalCost.name"
                              ),
                              readonly:
                                _vm.$store.state.DelegationOrder.readonly ===
                                true
                            },
                            on: {
                              "update:model": function($event) {
                                return _vm.$set(
                                  _vm.editedDelegationOrder,
                                  "estimated_total_cost",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card",
            [
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.cancel()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                  ),
                  _vm.$store.state.DelegationOrder.readonly !== true
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            disabled: _vm.$store.getters["Ajax/loading"],
                            color: "blue darken-1",
                            text: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.save()
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.editedDelegationOrder.id === null
                                  ? _vm.$t("global.add")
                                  : _vm.$t("global.save")
                              ) +
                              " "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }